import React from 'react';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import DialogInput from 'screens/components/advanced/DialogInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

const VisitPoint = (props) => {
    return (
        <DialogInput
            title={<DialogHeaderWithClose text="Visit Count" handleClose={() => props.closeVisits()}/>}
            className="checkIn_list"
            modal={true}
            autoScrollBodyContent={true}
            handleClose={() => props.closeVisits()}
            open={props.openDiag}
        >
            <div className="pt-2" >
                <TextInput className="pointsInput"
                    name="VisitAmount"
                    type="number"
                    label="Amount"
                    floatingLabelText="Amount"
                    hintText="Amount"
                    fullWidth={true}
                    maxLength={10} />

                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pb-2 pt-1 text-right">
                    <Button
                        type="IconDeleteButton"
                        label="Deduct"
                        className="btn-danger"
                        onTouchTap={() => props.removeVisits()}
                    />
                    <Button
                        type="IconAddButton"
                        className="ml-2 btnNewBrandPOS"
                        onTouchTap={() => props.addVisits()}
                    />
                </div>
            </div>
        </DialogInput>
    );
};

export default VisitPoint;